export default __webpack_public_path__ + "static/media/bmc-button-slimmer.e4d221cf.png";